import { SubjectJsonModel } from '../../subject.json.model';

export namespace SubjectActions {
  export class Add {
    static readonly type = getActionName('Add Subject');
    constructor(readonly payload: SubjectJsonModel) {}
  }

  export class Edit {
    static readonly type = getActionName('Edit Subject');
    constructor(readonly payload: SubjectJsonModel) {}
  }

  export class Delete {
    static readonly type = getActionName('Delete Subjects');
    constructor(readonly payload: SubjectJsonModel) {}
  }

  export class Fetch {
    static readonly type = getActionName('Fetch Subjects');
  }

  export class FetchAll {
    static readonly type = getActionName('Fetch all Subjects');
  }

  export class FetchSuccess {
    static readonly type = getActionName('Fetch Subjects success');
    constructor(readonly payload: SubjectJsonModel[]) {}
  }

  function getActionName(type: string) {
    return `[Subject] ${type}`;
  }
}
